import React  from 'react';
import { TextField, Button } from '@mui/material';
import '../assets/scss/filters.scss';
import { Print } from '@mui/icons-material';

const WalletFilters = ({ filters, setFilters, exportTransactions }) => {
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFilters((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    return (
        <div className="wallet-filters">
            <div className="filters-fields">
                <TextField
                    label="Data Inicial"
                    type="date"
                    fullWidth
                    size="small"
                    name="startDate"
                    value={filters.startDate}
                    onChange={handleChange}
                />

                <TextField
                    label="Data Final"
                    type="date"
                    fullWidth
                    size="small"
                    name="endDate"
                    value={filters.endDate}
                    onChange={handleChange}
                />
            </div>

            <div className="filters-buttons">
                <Button
                    variant="contained"
                    color="primary"
                    onClick={exportTransactions}
                    endIcon={<Print />}
                >
                    Exportar
                </Button>
            </div>
        </div>
    );
};

export default WalletFilters;
